.root {
  display: grid;
  gap: 12px 16px;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
}
